import { render, staticRenderFns } from "./task-quota.vue?vue&type=template&id=319ead5a"
import script from "./task-quota.vue?vue&type=script&lang=js"
export * from "./task-quota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports